import React from 'react'

import axios from 'axios'

import { getDmp, getDmpProduct, uniqueDmps } from '../../lib/format-dmps'

// props:
// @dmp value
// @dmpProduct value
// onDmpChange()
// onDmpProductChange()
export default class GDPR extends React.Component {
    state = {}

    componentDidMount() {
        axios.get('/partner').then(response => {
            console.log('get partner ', response.data)
            this.setState({ partner: response.data.body[0].partnerSettings || {} })
        })
    }
    confirmGDPR() {
        console.log('confirm GDPR')
        axios.post('/partner/gdpr', { partnerId: this.state.partner.partnerId }).then(response => {
            this.setState({ partner: response.data.body })
            /*setTimeout(() => {
                window.location.reload()
            }, 500)*/
        })
    }

    render() {
        if (this.state.partner && this.state.partner.region == 'eu' && this.state.partner.gdprConfirm == 0) {
            return (
                <div className="row" style={{ 'margin-bottom': '10px' }}>
                    <div className="col-12">
                        <div className="alert alert-warning" role="alert">
                            GDPR policy: the data uploaded might transit in services located outside of Europe. We do not store or process any personal user
                            data. &#160;
                            <a onClick={this.confirmGDPR.bind(this)} href="#">
                                Accept
                            </a>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <span />
        }
    }
}
